// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"6a421035","639":"fc6c17d6"}[chunkId] + ".chunk.js";
};